(() => {
  const escapeHtml = (value) => String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');

  const metricPercent = (metric) => `${Number(metric?.percent || 0)}%`;

  function initReviewsRoot(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const endpoint = (root.dataset.endpoint || '').trim();
    const productHandle = (root.dataset.productHandle || '').trim();
    const limit = Number(root.dataset.limit || 8);
    const loading = root.querySelector('[data-loading]');
    const errorBox = root.querySelector('[data-error]');
    const grid = root.querySelector('[data-review-grid]');
    const metrics = root.querySelector('[data-metrics]');
    const ratingPanel = root.querySelector('[data-rating-panel]');

    async function loadReviews() {
      if (!endpoint) throw new Error('The review endpoint is not configured.');

      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set('action', 'reviews');
      if (productHandle) url.searchParams.set('product_handle', productHandle);

      const response = await fetch(url.toString(), { redirect: 'follow' });
      const text = await response.text();
      let data;

      try {
        data = JSON.parse(text);
      } catch (error) {
        if (/accounts\.google\.com|ServiceLogin|Sign in/i.test(text) || /accounts\.google\.com/i.test(response.url)) {
          throw new Error('The review service requires a Google login.');
        }
        throw new Error('The review service did not return JSON.');
      }

      if (!response.ok || !data.ok) throw new Error(data.error || `Request failed (${response.status}).`);

      const summary = data.summary || {};
      const reviews = Array.isArray(data.reviews) ? data.reviews.slice(0, limit) : [];

      root.querySelector('[data-average-rating]').textContent = Number(summary.average_rating || 0).toFixed(1);
      root.querySelector('[data-rating-count]').textContent = Number(summary.rating_count || 0);
      root.querySelector('[data-participants]').textContent = Number(summary.participants || 0);
      root.querySelector('[data-easy]').textContent = metricPercent(summary.easy_to_put_on);
      root.querySelector('[data-errands]').textContent = metricPercent(summary.errand_comfort);

      grid.innerHTML = reviews.length ? reviews.map((review) => {
        const numericRating = Math.max(0, Math.min(5, Math.round(Number(review.rating || review.overall_rating || 0))));
        const stars = '★★★★★'.slice(0, numericRating);
        const body = review.review || review.review_body || '';
        const details = [review.age_range, review.size_tested, review.primary_routine].filter(Boolean).join(' · ');

        return `
          <article class="cara-lp-review-card">
            <div class="cara-lp-review-card__stars" aria-label="${numericRating} out of 5 stars">${stars}</div>
            <h3>${escapeHtml(review.headline || 'Cara wear-test review')}</h3>
            <p>${escapeHtml(body)}</p>
            <footer>
              <strong>${escapeHtml(review.display_name || 'Anonymous wear tester')}</strong>
              <span>${escapeHtml(details)}</span>
            </footer>
          </article>
        `;
      }).join('') : `
        <article class="cara-lp-review-card">
          <h3>Approved reviews are being prepared.</h3>
          <p>Visit the panel review page for the latest published results and methodology.</p>
        </article>
      `;

      loading.hidden = true;
      errorBox.hidden = true;
      grid.hidden = false;
      metrics.hidden = false;
      ratingPanel.hidden = false;
    }

    const run = () => {
      if (loading) loading.hidden = false;
      loadReviews().catch((error) => {
        loading.hidden = true;
        errorBox.textContent = `Reviews could not be loaded. ${error.message || ''}`;
        errorBox.hidden = false;
      });
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          obs.disconnect();
          run();
        }
      }, { rootMargin: '200px 0px' });
      observer.observe(root);
    } else {
      run();
    }
  }

  document.querySelectorAll('[data-cara-reviews-root]').forEach(initReviewsRoot);
})();
